var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { List, ListBullet, ListItem, Paragraph } from '../Common';
import { TutorialSection } from './TutorialSection';
var REPORTS_TUTORIAL_ITEMS = [
    'Weekly and Yearly Dashboards',
    'Skills Report',
    'Happy Numbers Assignments',
    'Happy Numbers Printables',
    'Parent Report',
];
var ScParagraph = styled(Paragraph).withConfig({ displayName: "ScParagraph", componentId: "sc-1w81btj" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-bottom: 10px;\n"], ["\n  margin-bottom: 10px;\n"])));
var ReportsTutorial = function (props) {
    return (_jsxs(TutorialSection, __assign({}, props, { title: 'Master your teacher account to optimize your Happy Numbers experience', video: 'reports', buttonLabel: 'Watch 25-minute Tutorial' }, { children: [_jsxs(ScParagraph, { children: ["This informative 25-minute tutorial walks you through", _jsx("br", {}, void 0), "key features that will support your instruction:"] }, void 0), _jsx(List, { children: REPORTS_TUTORIAL_ITEMS.map(function (item, index) { return (_jsxs(ListItem, { children: [_jsx(ListBullet, {}, void 0), item] }, index)); }) }, void 0)] }), void 0));
};
export { ReportsTutorial, REPORTS_TUTORIAL_ITEMS };
var templateObject_1;
